const setCSSVariables = (theme: any) => {
  console.log('Aplicando tema:', theme);

  // Recorrer la paleta
  for (const color in theme.palette) {
    const colorValue = theme.palette[color];

    if (typeof colorValue === 'object') {
      for (const prop in colorValue) {
        const value = colorValue[prop];

        // Manejo especial de la propiedad 'opacity' anidada
        if (prop === 'opacity' && typeof value === 'object') {
          for (const level in value) {
            document.documentElement.style.setProperty(
              `--color-${color}-opacity-${level}`,
              value[level]
            );
          }
        } else {
          document.documentElement.style.setProperty(
            `--color-${color}-${prop}`,
            value
          );
        }
      }
    } else {
      // Por si es string directo
      document.documentElement.style.setProperty(`--color-${color}`, colorValue);
    }
  }

  // Tipografía
  if (theme.typography) {
    for (const prop in theme.typography) {
      document.documentElement.style.setProperty(`--typography-${prop}`, theme.typography[prop]);
    }
  }

  // Transiciones
  if (theme.transitions) {
    for (const key in theme.transitions) {
      document.documentElement.style.setProperty(`--transitions-${key}`, theme.transitions[key]);
    }
  }

  // Sombras
  if (theme.shadows) {
    theme.shadows.forEach((value: any, index: number) => {
      document.documentElement.style.setProperty(`--shadows-${index}`, value);
    });
  }
};

export default setCSSVariables;
export {}; // Para evitar el error de "no es un módulo"
